import { motion } from 'framer-motion'
import React, { useEffect, useState } from 'react'
import ReactGA from 'react-ga'
import { IoIosArrowForward } from 'react-icons/io'
import { useDispatch } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import ym from 'react-yandex-metrika'

import { articleCards } from '../../../consts/articlesCards'
import { getAnimationFourParams } from '../../../helpers/animations'
import { setPageName } from '../../../store/page/actions'
import styles from './articles.module.scss'
import { ArticlesTypes } from './Articles.types'

export const Articles = ({ excludeId, mainPage }: ArticlesTypes) => {
  const { pathname } = useLocation()
  const [cardCount, setCardCount] = useState<number>(2)
  const dispatch = useDispatch()

  const articleClick = (id: string, name: string) => {
    ReactGA.ga('send', 'event', 'article', 'see also bottom', name)

    ym('reachGoal', 'see also event', {
      'see also event': {
        [`Со статьи ${excludeId}`]: `Статья ${id}`,
      },
    })
  }

  useEffect(() => {
    window.scrollTo(0, 0)
    dispatch(setPageName('article'))
    setCardCount(2)
  }, [pathname])

  return (
    <div className={mainPage && styles.articleMainBlock}>
      <motion.div
        {...getAnimationFourParams()}
        className={styles.articlesWrapper}
        id='#articles'
      >
        <h2 className={styles.articlesTitle}>
          {mainPage ? 'Статьи' : 'Читайте также'}
        </h2>
        <div className={styles.articleCards}>
          {articleCards.map(
            (el, index) =>
              excludeId !== el.id &&
              index <= (mainPage ? cardCount : cardCount + 1) && (
                <Link
                  className={styles.selectionCard}
                  to={`/article/${el.id}`}
                  onClick={() => articleClick(el.id, el.name)}
                  key={el.id}
                >
                  <div className={styles.selectionCard__image}>
                    <img src={el.image} alt='' />
                  </div>
                  <div className={styles.cardDescription}>
                    <p>{el.name}</p>
                    <button className={styles.cardBtn}>
                      Читать <IoIosArrowForward />
                    </button>
                  </div>
                </Link>
              )
          )}
        </div>
        {articleCards.length > (mainPage ? cardCount + 1 : cardCount + 2) && (
          <button
            className={styles.showAllBtn}
            onClick={() => {
              setCardCount(prev => prev + 3)
            }}
          >
            Показать ещё
          </button>
        )}
      </motion.div>
    </div>
  )
}
